import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const EditableSpan = styled('span')(() => {
  return {
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  };
});

const ClickToEditInput = ({ inputProps }) => {
  const [editing, setEditing] = useState(false);

  const beginEditing = () => {
    setEditing(true);
  };

  const endEditing = () => {
    setEditing(false);
  };

  const renderItemOrEditField = () => {
    if (editing === true) {
      return (
        <TextField
          {...inputProps}
          onClick={beginEditing}
          onBlur={endEditing}
          autoFocus
          placeholder="Enter value"
          size="small"
        />
      );
    }
    return (
      <EditableSpan onClick={beginEditing}>
        {inputProps.value || 'Click to edit'}
      </EditableSpan>
    );
  };

  return renderItemOrEditField();
};

ClickToEditInput.propTypes = {
  inputProps: PropTypes.object.isRequired,
};

export default ClickToEditInput;
